import Card from '../card/Card';
import Label from '../texts/label/Label';
import P from '../texts/p/P';
import { useClientTheme } from '../../context/ThemeContext';

interface IStepProps {
  widthContainer: string;
  widthCircle1: string;
  widthCircle2: string;
  widthId: string;
  heightId: string;
  step: {
    id: number;
    value: string;
  };
  index: number;
  currentStep: number;
  changeStep: (stepId: number) => void;
  stepsLength: number;
}

const Step = ({
  widthContainer,
  widthCircle1,
  widthCircle2,
  widthId,
  heightId,
  step,
  index,
  currentStep,
  stepsLength,
  changeStep,
}: IStepProps) => {
  const { clientTheme } = useClientTheme();
  
  return (
    <Card width={widthContainer}>
      <Card display='flex' alignItems='center'>
        <Card
          width={widthCircle1}
          height='2px'
          variant='neutral'
          modifier={index === 0 ? 'inverted' : 'weak'}
          borderRadiusAmount='1'
        ></Card>
        <Card
          variant={currentStep === step.id ? (clientTheme ? 'primary' : 'success') : 'neutral'}
          modifier='inverted'
          spacing={'2'}
          width={widthId}
          height={heightId}
          borderRadiusAmount='5'
          border
          onClick={() => changeStep(index + 1)}
        >
          <P
            align='center'
            variant='neutral'
            modifier={currentStep === step.id ? 'strong' : 'weak'}
            withMargin={false}
          >
            {step.id}
          </P>
        </Card>
        <Card
          width={widthCircle2}
          height='2px'
          variant='neutral'
          modifier={index + 1 === stepsLength ? 'inverted' : 'weak'}
          borderRadiusAmount='1'
        ></Card>
      </Card>

      <Card display='flex' justifyContent='center' margin={{ top: '2' }}>
        <Label type='4' weight='bold' variant='neutral'>
          {step.value}
        </Label>
      </Card>
    </Card>
  );
};
export default Step;
